import React, { useRef } from 'react'
import ThisProject from '../ThisProject';
import MotionContent from '../../components/containers/MotionContent';
import { ImageMedia } from '../../components/imports';

const Content = () => {

  const heroRef = useRef(null);
  return (
    <ThisProject>
      {({ thisProject, projectId, prLink }) => (
        <div className='projectContent'>
          <MotionContent imgRef={heroRef} height={"110vh"} className="bg-black overflow-visible">
            <ImageMedia
              key={"hero"+thisProject.client}
              src={require('./_cover.jpg')}
              className="relative md:landscape:scale-[120%]= full object-cover object-top"
            />
          </MotionContent>
        </div>
      )}
    </ThisProject>
  )
}

export default Content